import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-payment-request',
  templateUrl: './payment-request.component.html'
})

export class PaymentRequestComponent implements OnInit {
  private baseUrl: string;
  private http: HttpClient;
  private route: ActivatedRoute;

  model: PayViewModel;
  message: string;
  gateways: Gateway[];

  constructor(http: HttpClient, route: ActivatedRoute, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
    this.http = http;
    this.route = route;
    this.model = new PayViewModel();
    this.model.generateTrackingNumberAutomatically = true;
  }

  ngOnInit(): void {
    this.message = 'در حال انتقال...';
    const trackingCode = this.route.snapshot.paramMap.get('tc');

    this.http.get<ServiceResult<PaymentRequestResultViewModel>>(
      `${environment.ServicesUrl}${environment.PayResultEndpoint}`
      .replace('{trackingCode}', trackingCode))
      .subscribe(result => {
      if (result.hasError) {
        alert(result.message);
        return;
      }

      if (result.result.transporter === null)
        this.message = 'تراکنش یافت نشد';
      else
        this.transportToGateway(result.result.transporter);

    }, error => console.error(error));
  }

  transportToGateway(transporter: GatewayTransporter) {
    if (transporter.type === TransportType.Redirect) {
      // Transporting with Redirect
      window.location.href = transporter.url;
    } else {
      // Transporting with Form
      const form = document.createElement('form');
      form.setAttribute('id', 'myForm');
      form.setAttribute('method', 'post');
      form.setAttribute('action', transporter.url);

      transporter.form.forEach(item => {
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', item.key);
        input.setAttribute('value', item.value);
        form.appendChild(input);
      });

      document.getElementsByTagName('body')[0].appendChild(form);
      (document.getElementById('myForm') as HTMLFormElement).submit();
    }
  }
}

class PayViewModel {
  trackingNumber: number;
  generateTrackingNumberAutomatically: boolean;
  amount: number;
  selectedGateway: number;
}

interface Gateway {
  name: string;
  value: number;
}

interface ServiceResult<T> {
  hasError: boolean;
  message: string;
  referenceId: string;
  result: T;
}

interface PaymentRequestResultViewModel {
  isSucceed: boolean;
  message: string;
  transporter: GatewayTransporter;
}

interface GatewayTransporter {
  type: TransportType;
  url: string;
  form: KeyValuePair[];
}

interface KeyValuePair {
  key: any;
  value: any;
}

enum TransportType {
  Post,
  Redirect
}
